module.exports = __webpack_public_path__ + "static/media/logo.46477ee1.svg";